export default "__VITE_ASSET__DMVaN28k__"